import { any, array, bool, func, string } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import AddItemButton from './AddItemButton'
import PhaseContextualMenu from './PhaseContextualMenu'

import './styles.scss'

const Footer = ({
  addItem,
  className,
  disabled,
  onContextMenuAction,
  ...otherProps
}) => (
  <div className={kuiperClassNames(className, 'phase-footer', { disabled })}>
    <div className={kuiperClassNames('phase-footer-content', 'hasBgColor')}>
      <AddItemButton addItem={addItem} disabled={disabled} {...otherProps} />

      <PhaseContextualMenu
        onContextMenuAction={onContextMenuAction}
        phase={otherProps}
      />
    </div>
  </div>
)

Footer.propTypes = {
  addItem: func,
  className: any,
  disabled: bool,
  items: array,
  onContextMenuAction: func.isRequired,
  onRetractApprovals: func,
  phaseType: string.isRequired,
}

export default Footer
